<template>
  <keep-alive include="UserList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "User",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
